export function InvoiceDetailsErrorState() {
  return (
    <div className="border-c-border text-c-card-muted rounded border px-3 py-3 text-xs">
      Failed to load invoice details.
    </div>
  );
}
